import selectors from '../../../rootSelectors';
import { resetQuestionsAndTimeTrackingState } from '../../../common/questions/questionsActions';
import { goToStartPage, goToQuestion } from '../../../common/navigation/navigationActions';
import { NW } from '../../../constants/measure';
import { QUESTIONS } from '../../../constants/assessmentItemType';

const onNextButtonClick = (questionIndex) => (dispatch, getStore) => {
    const state = getStore();
    const isLastQuestion = selectors.getNWTotalQuestions(state, QUESTIONS) < questionIndex + 1;
    if (isLastQuestion) {
        dispatch(goToStartPage());
    } else {
        dispatch(goToQuestion(NW.ASSESSMENT, null, questionIndex + 1));
        dispatch(resetQuestionsAndTimeTrackingState());
    }
};

export default onNextButtonClick;
